const highlights = [
  {
    icon: "ri-seedling-line",
    title: "Premium Agricultural Exporter",
    description: "Specializing in high-value Indian agricultural products with global export standards.",
    color: "bg-[#D8F3DC]",
    iconColor: "text-[#2D6A4F]"
  },
  {
    icon: "ri-links-line",
    title: "Direct Sourcing from Trusted Suppliers",
    description: "We work closely with vetted farmers and growers ensuring authenticity and quality at origin.",
    color: "bg-[#FEF9C3]",
    iconColor: "text-[#C9A227]"
  },
  {
    icon: "ri-check-double-line",
    title: "Export-Quality Processing",
    description: "Strict cleaning, grading, and hygienic processing before every shipment.",
    color: "bg-[#D8F3DC]",
    iconColor: "text-[#2D6A4F]"
  },
  {
    icon: "ri-global-line",
    title: "Reliable Global Supply Chain",
    description: "Serving international buyers with consistent timely deliveries across global markets.",
    color: "bg-[#FEF9C3]",
    iconColor: "text-[#C9A227]"
  }
];

export default function About() {
  return (
    <section id="about" className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-14 lg:gap-20 items-center">
          {/* Left – image + decorative */}
          <div className="w-full lg:w-[45%] flex-shrink-0">
            <div className="relative">
              <div className="rounded-2xl overflow-hidden">
                <img
                  src="https://public.readdy.ai/ai/img_res/ee1c2c97fa63239956d659240abdc777.jpg"
                  alt="About Pandit Export"
                  className="w-full h-[400px] md:h-[500px] object-cover object-top"
                />
              </div>
              {/* Floating badge */}
              <div className="absolute -bottom-6 -right-4 md:-right-8 bg-[#1B4332] text-white px-6 py-5 rounded-2xl shadow-xl">
                <p className="text-3xl font-bold text-[#C9A227]">2026</p>
                <p className="text-xs text-white/80 mt-1 uppercase tracking-wider">Est. Year</p>
              </div>
              <div className="absolute -top-4 -left-4 md:-left-6 bg-[#C9A227] text-white px-5 py-4 rounded-2xl shadow-xl">
                <p className="text-2xl font-bold">25 KG+</p>
                <p className="text-xs text-white/90 mt-0.5 uppercase tracking-wider">Min. Order</p>
              </div>
            </div>
          </div>

          {/* Right – content */}
          <div className="w-full lg:w-[55%]">
            <span className="inline-block text-[#C9A227] text-xs font-bold tracking-widest uppercase border border-[#C9A227] px-3 py-1 rounded-full mb-4">
              Who We Are
            </span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#1B4332] mb-6 leading-tight" style={{ fontFamily: "'Playfair Display', serif" }}>
              About Pandit Export
            </h2>
            <p className="text-gray-600 text-base md:text-lg leading-relaxed mb-4">
              Pandit Export is a dynamic export business specializing in <strong className="text-[#2D6A4F]">premium Indian agricultural and natural products</strong>. Founded by <strong className="text-[#1B4332]">Dhrubajit Pandit</strong>, Founder &amp; Exporter, we supply high-quality Dooars Tea, Assam Tea, Lakadong Turmeric, White Turmeric, and a wide range of Indian spices to global markets.
            </p>
            <p className="text-gray-600 text-base leading-relaxed mb-8">
              We work closely with trusted farmers and suppliers to ensure <strong className="text-[#2D6A4F]">consistent quality</strong>, competitive pricing, and reliable delivery. Our goal is to connect global buyers with authentic Indian products through transparency, professionalism, and long-term partnerships.
            </p>

            {/* Details list */}
            <div className="grid grid-cols-2 gap-3 mb-8">
              {[
                { label: "Owner", value: "Dhrubajit Pandit" },
                { label: "Type", value: "Proprietorship" },
                { label: "Certification", value: "Trade License" },
                { label: "Target", value: "Global Markets" },
                { label: "Category", value: "Exporter & Trader" },
                { label: "Est.", value: "2026" },
              ].map((item) => (
                <div key={item.label} className="flex gap-2">
                  <span className="w-4 h-4 flex items-center justify-center text-[#C9A227] mt-0.5 flex-shrink-0">
                    <i className="ri-checkbox-circle-fill text-sm"></i>
                  </span>
                  <div>
                    <span className="text-xs text-gray-400 uppercase tracking-wide">{item.label}</span>
                    <p className="text-sm font-semibold text-[#1B4332]">{item.value}</p>
                  </div>
                </div>
              ))}
            </div>

            {/* Address */}
            <div className="flex items-start gap-3 mb-8 p-4 rounded-xl bg-[#F7FAF8] border border-[#D8F3DC]">
              <span className="w-8 h-8 flex items-center justify-center rounded-full bg-[#D8F3DC] text-[#2D6A4F] flex-shrink-0 mt-0.5">
                <i className="ri-map-pin-line text-sm"></i>
              </span>
              <div>
                <p className="text-xs text-gray-400 uppercase tracking-wide mb-0.5">Our Location</p>
                <p className="text-sm font-semibold text-[#1B4332] leading-relaxed">
                  Barobisha, Jorai Road,<br />
                  Alipurduar – 736207,<br />
                  West Bengal, India
                </p>
              </div>
            </div>

            <button
              onClick={() => document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" })}
              className="inline-flex items-center gap-2 bg-[#2D6A4F] hover:bg-[#1B4332] text-white font-semibold px-7 py-3.5 rounded-full transition-all duration-200 cursor-pointer whitespace-nowrap"
            >
              <span className="w-5 h-5 flex items-center justify-center">
                <i className="ri-mail-line"></i>
              </span>
              Get In Touch
            </button>
          </div>
        </div>

        {/* Highlight Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 mt-20">
          {highlights.map((item, i) => (
            <div
              key={i}
              className="group p-6 rounded-2xl border border-gray-100 bg-white hover:shadow-lg transition-all duration-300 hover:-translate-y-1 cursor-default"
            >
              <div className={`w-14 h-14 flex items-center justify-center rounded-xl ${item.color} mb-4`}>
                <span className={`text-2xl ${item.iconColor}`}>
                  <i className={item.icon}></i>
                </span>
              </div>
              <h3 className="text-base font-bold text-[#1B4332] mb-2">{item.title}</h3>
              <p className="text-sm text-gray-500 leading-relaxed">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
